var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPagePortfolio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,49V1H8v5H6v2h2v4H6v2h2v4H6v2h2v4H6v2h2v4H6v2h2v4H6v2h2v4H6v2h2v5H44z M10,38h2v-2h-2v-4h2v-2h-2v-4h2v-2h-2v-4h2v-2   h-2v-4h2v-2h-2V8h2V6h-2V3h32v44H10v-3h2v-2h-2V38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,8H17v14h20V8z M35,20H19V10h16V20z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 14,
    x: 20,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 14,
    x: 20,
    y: 31
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagePortfolio);
export default __webpack_public_path__ + "static/media/page_portfolio.64eb42e345cb648cf3b80116359d452b.svg";
export { ForwardRef as ReactComponent };